import HeroSection from "@/pages/home/components/HeroSection";
import NewsHighlights from "@/pages/home/components/NewsHighlights";
import PlotFeature from "@/pages/home/components/PlotFeature";
import CastShowcase from "@/pages/home/components/CastShowcase";
import RecommendSection from "@/pages/home/components/RecommendSection";
import SiteIntro from "@/pages/home/components/SiteIntro";
import { useSeo } from "@/hooks/useSeo";

export default function Home() {
  useSeo({
    title: "蜜桃成熟时3D - 最新电影资讯与剧情介绍",
    description:
      "蜜桃成熟时3D官方网站，提供最新电影资讯、剧情介绍以及相关影视内容，带您深入了解影片详情和演员阵容。",
    keywords: "蜜桃成熟时3D,电影,剧情介绍,影视资讯,演员阵容,电影预告",
    path: "/",
  });

  return (
    <>
      <h1 className="sr-only">蜜桃成熟时3D · 影视资讯门户</h1>
      <HeroSection />
      <NewsHighlights />
      <PlotFeature />
      <CastShowcase />
      <RecommendSection />
      <SiteIntro />
    </>
  );
}